import React, { useEffect, useState, CSSProperties } from 'react';
import { Row, Col } from 'react-bootstrap';

import ConsumptionOverview from '../charts/consumptionOverview';
import { getConsumptionOverviewData } from '../../services/consumer.service';
//import { AuthUser, selectUser } from '../../slices/auth.slice';
//import { useAppSelector } from '../../app/hooks';
//import CFCOverview from '../../data/consumer/CFCOverview.json';
import DotLoader from "react-spinners/DotLoader";
import moment from 'moment';
//import { START_DATE } from '../../prosumerComponents/common/const';

// Datepicker
const override: CSSProperties = {
	display: "block",
	margin: "auto",
	marginTop: "100px",
	borderColor: "red",
};

interface ConsumptionChartObject {
	meterType: string;
	net_earnings: number;
	traded: {
		name: string,
		allocation: string,
		cost: string,
		distributionPercentage: number
	};
	energy_load: {
		name: string,
		allocation: string,
		cost: string,
		distributionPercentage: number
	};
}

const ConsumptionOverviewPage = (props: any) => {
	//const authUser: AuthUser = useAppSelector(selectUser);
	//const auth = JSON.parse(localStorage.getItem('auth')!)
	const [data, setData] = useState<ConsumptionChartObject>()
	let [loading, setLoading] = useState(false);
	const color = "#006837";
	const startDate = new Date();
	startDate.setDate(startDate.getDate() - 1);
	useEffect(() => {
		const fetchData = async () => {
			setLoading(true)

			const dataSet = await Promise.all(props.userList.map(async (item: any) => {
				const data = await getConsumptionOverviewData(item,
					Number(moment(new Date(startDate)).format('YYYY')),
					Number(moment(new Date(startDate)).format('M')),
					1);
				return data.data;
			}));

			let tradedTotalEnergyMonth = 0;
			let tradedTotalEarningsMonth = 0;
			let unFilledTotalEnergyMonth = 0;
			let unFilledTotalPaidMonth = 0;

			await Promise.all(
				dataSet.map(async (element: any) => {
					tradedTotalEnergyMonth = tradedTotalEnergyMonth + Number(element.traded.allocation);
					tradedTotalEarningsMonth = tradedTotalEarningsMonth + Number(element.net_earnings);
					unFilledTotalEnergyMonth = unFilledTotalEnergyMonth + Number(element.energy_load.allocation);
					unFilledTotalPaidMonth = unFilledTotalPaidMonth + Number(element.energy_load.cost);
				}),
			);

			const data: any = {
				meterType: dataSet[0].meterType,
				net_earnings: Number(tradedTotalEarningsMonth.toFixed(2)),
				traded: {
					name: 'Green Attribute',
					allocation: Number(tradedTotalEnergyMonth).toFixed(4),
					cost: Number(tradedTotalEarningsMonth).toFixed(2),
					distributionPercentage: 100,
				},
				energy_load: {
					name: 'Energy Load',
					allocation: Number(unFilledTotalEnergyMonth).toFixed(4),
					cost: Number(unFilledTotalPaidMonth).toFixed(2),
					distributionPercentage: 0,
				},
			};
			setData(data)
			setLoading(false)
		}
		fetchData();
	}, [props.userList])

	return (
		<div className='dashboardWidget'>
			<div className='widgetTitle'>
				<Row>
					<Col sm="7"><h3>24/7 CFE Overview</h3></Col>
					{/* <Col sm="5" className=' text-end'>
				<label className='reactdatepicker-label datepickerOverview' htmlFor="reactDatePickerOverview">
					<DatePicker 
						dateFormat="MMMM, yyyy"
						selected={startDate} 
						className="datepicker"
						id='reactDatePickerOverview'
						// onChange={date => date && setStartDate(date)}
						onChange={date => onDateChange(date)}
						showMonthYearPicker
					/>
				</label>
			</Col> */}
				</Row>
			</div>
			{loading ? <DotLoader
				color={color}
				loading={loading}
				cssOverride={override}
				size={50}
				aria-label="Loading Spinner"
				data-testid="loader"
			/> :
				<div className='widgetBody py-3'>
					<div className='widgetChart'>
						<Row>
							<Col md="6">
								<ConsumptionOverview greenEnerge={data?.traded?.allocation} energyLoad={data?.energy_load.allocation} text="Green Energy" />
								<p style={{ textAlign: 'center', marginTop: '18px' }}>Energy Load</p>
							</Col>
							<Col md="6">
								<div className='totalConsumption text-end'>
									<p className='mb-0'>Total consumption in {moment(new Date(startDate)).format('MMMM').toUpperCase()}</p>
									<h2 className='h1 mb-0'>{data?.net_earnings.toFixed(2)} ฿</h2>
									{/* <small>Total Consumption So Far on October</small> */}
								</div>
								<hr />

								<ul className='consumptionLedgend'>
									<li><i style={{ backgroundColor: '#006837' }}></i><span>Green Attribute</span> <span className='count'>{parseFloat(data ? data.traded.cost : "").toFixed(2)} ฿<br /><small>({data?.traded.allocation} kWh)</small></span></li>
									<li><i style={{ backgroundColor: '#E16839' }}></i><span>Unfilled load</span> <span className='count'>{parseFloat(data ? data.energy_load.cost : "").toFixed(2)} ฿<br /><small>({data?.energy_load.allocation} kWh)</small></span></li>
								</ul>
							</Col>
						</Row>
					</div>
				</div>}

		</div>
	)
}
export default ConsumptionOverviewPage;
